import { getSocialInsuranceDailyBase } from '../LegalParameters/SocialInsuranceDailyBase';

export function getDailyIncome(income) {
	return (income * 12) / 365;
}

export function getRate(reduction) {
	return Math.ceil(0.6 * reduction);
}

export function getDays(sickDays, lonelyParent) {
	return Math.min(lonelyParent, sickDays);
}

export function getTotal(rate, days) {
	return rate * days;
}

export default function({ pay, sickDays, lonelyParent, year }) {
	const dailyIncome = getDailyIncome(pay);
	const reduction = getSocialInsuranceDailyBase({
		income: dailyIncome,
		year,
	});
	const rate = getRate(reduction);
	const days = getDays(sickDays, lonelyParent);
	const total = getTotal(rate, days);

	return {
		rate,
		days,
		total,
	};
}
